import React, { useState, useMemo } from "react";
import OverflowingComponentsContext from "views/components/contexts/OverflowingComponentsContext";
const OverflowingComponentsContextProvider = ({ children }) => {
  const [overflowingComponents, setOverflowingComponents] = useState({});
  const contextValue = useMemo(() => ({ overflowingComponents, setOverflowingComponents }), [overflowingComponents]);
  const overflowingComponentsValues = Object.values(overflowingComponents);
  return /* @__PURE__ */ React.createElement(OverflowingComponentsContext.Provider, { value: contextValue }, children, overflowingComponentsValues);
};
export default OverflowingComponentsContextProvider;
